import { Market } from "Types/File";

export function isEventMarketOnly(markets: Market[] | undefined): boolean {
  return markets?.length === 1 && markets[0] === Market.event;
}
